import React, { Component } from 'react';
import { Link, useNavigate } from "react-router-dom";
import API from "../../config/api";
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class CategoryView extends Component {

    constructor(props) {
        super(props)
      
        this.state = {
          page: 1,
          category_id: 1,
          categories: [],
          total: 0,
          questions: [],
          all_categories: []
          
        }
      }
      UNSAFE_componentWillMount() {
        this.getParam("id");
        this.getOneCategory();
        this.getQuestionByCategory();
        this.getAllCategories();
      }

      getParam(name) {
        let id = window.location.search.split(`${name}=`)[1]
        this.state.category_id = id;
        this.setState({})
      }

      getAllCategories = async () => {
        try {
          let query = `page=${this.state.page}`
          let results = await API.getAllCategory(query);
          let data = results.data;
          
          this.setState({ all_categories : data.category });
    
        } catch (error) {
          console.log(error)
        }
      }
    
      getOneCategory = async () => {
        
        try {
          let query = `category_id=${this.state.category_id}`
          let results = await API.getOneCategory(query);
    
          let data = results.data;
          this.setState({ categories : data});
    
        } catch (error) {
          console.log(error)
        }
      }

      getQuestionByCategory = async () => {
        try {
          let query = "";

          if (this.state.category_id) {
            query = `category_id=${this.state.category_id}`
          }
          let results = await API.getAllQuestions(query);
          let data = results.data.result;

          this.setState({questions: data.quiz, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      onChangeFile = async (event) => {
        event.preventDefault();
        let file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        
        try {
          let results = await API.adminUpload(
            formData,
            this.onUploadProgress
          );
          
          if (results){
            this.setState({ thumbnail_url: results.filename })
          }
    
        } catch (error) {
          console.log(error)
        }
      }

      async updateTestAvailable(data) {
        await API.updateTestQuestion({
          id: data.id,
          test_available: data.test_available
        }) ;
        toast.success("Your action is successful")
        
    }

      onSearch = async (event) => {
        // cateogory_id=1 , s=code,limit=100
        event.preventDefault();
        let value = event.target.value;
        try {
          let query = `s=${value}`
          let results = await API.getAllVideos(query);
          
          let data = results.data.result;
          
          this.setState({ questions : data.quiz, total: data.total });
    
        } catch (error) {
          console.log(error)
        }
      }

      goBack = () => {
        this.props.navigate(-1); // Navigate to the previous page
      };
    
  render() {
    return (
        <div className="col-12">
          <ToastContainer />
            <form className="card">
                <h4 className="card-title"><strong>Category</strong></h4>

                <div className="card-body row">

                    <div className="col-md-6">
                    <div className="form-group">
                        <label className="require" for="input-required">Name</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.categories.name} disabled />
                    </div>
                    {/* <div className="form-group">
                        <label for="inputState" className="col-form-label">Parent</label>
                        <select id="inputState" className="form-control">
                        <option>Short Film</option>
                        <option>Funny</option>
                        <option>Love story</option>
                        <option>Sad story</option>
                        </select>
                    </div> */}
                    
                    </div>


                    <div className="col-md-6">
                    {/* <div className="form-group">
                        <label>Description</label>
                        <input type="text" className="form-control" id="input-required" value={this.state.categories.score} disabled />
                    </div> */}
                    </div>
                    {/* <div className="col-md-6">
                      <div className="form-group">
                          <label>Thumbnail</label>
                          <img className='h-300px w-fullscreen' src={this.state.categories.thumbnail_url} alt="..." />
                          <br />
                          <input type="file" data-provide="dropify" />
                      </div>
                    </div> */}


                    
                    

                    
                </div>




                <div className="card-body">

            {/* <div className="flexbox mb-20">
                <div className="lookup">
                  <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} />
                </div>

                <div className="btn-toolbar">
                  <div className="btn-group btn-group-sm">
                    <button className="btn" title="Refresh" data-provide="tooltip"><i class="ion-refresh"></i>  </button>
                    <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i></button>
                    <Link to="/categorynew" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round"></i></button></Link>
                    <Link to="/user/new" > <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i>New</button></Link>
                  </div>

                  <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                    <button className="btn dropdown-toggle" data-toggle="dropdown">Export</button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <a className="dropdown-item" href="/">CSV</a>
                      <a className="dropdown-item" href="/">SQL</a>
                      <a className="dropdown-item" href="/">PDF</a>
                      <a className="dropdown-item" href="/">Text</a>
                    </div>
                  </div>
                </div>
              </div> */}
            <div>
          </div>
          </div>





               

                <h4 className="card-title"><strong>Totla questions: <b className="text-success fw-500 w-80px"> {this.state.total.toLocaleString('en-US')}</b></strong></h4>
                <table className="table table-hover table-has-action">
                  <thead>
                    <tr>
                      <th>#</th>
                      {/* <th>Thumbnail</th> */}
                      <th>Test</th>
                      <th>Name</th>
                      <th>Question</th>
                      {/* <th>Description Kh</th>
                      <th>Description En</th> */}
                      <th>Code</th>
                      <th>Category</th>
                      <th>Release Date</th>
                      <th className="text-center w-150px">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    this.state.questions && this.state.questions.map((question, index)=> {
                      return <tr>
                        <th scope="row">{( (this.state.page - 1) * 10) + (index+ 1)}</th>
                        {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={video.thumbnail_url} alt="video thumbnail" /></td> */}
                        {/* <td>
                          <div class="media">
                            <img class="avatar" src={question.image_url ? question.image_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                            <div class="media-body">
                            </div>
                          </div>
                        </td> */}
                        <td>
                          <input 
                            type="checkbox"
                            defaultChecked={question.test_available}
                            onChange={(e) => {
                              this.updateTestAvailable({
                                id: question.id,
                                test_available: e.target.checked? 1 : 0
                              })
                            }}
                          />
                        </td>
                        <td>{question.name}</td>
                        <td>{question.question}</td>
                        {/* <td>{video.description_kh}</td>
                        <td>{video.description_en}</td> */}
                        <td className="w-100px">{question.code}</td>
                        <td className="w-100px">{this.state.all_categories.map((category, index) => {
                          if(category.id === question.category_id) {
                            return category.name
                          }
                           
                        })}</td>
                        <td>{moment(question.created_at).format("DD-MMM-YYYY")}</td>
                        <td className="text-right table-actions">
                          {/* <Link title="View" class="btn btn-square btn-round btn-primary" to={`/userview?id=${user.id}`}><i className="fa fa-eye"></i></Link> */}
                          <Link className="btn btn-square btn-round btn-primary" title="View" to={`/questionedit?id=${question.id}`}><i className="fa fa-eye"></i></Link>
                          <span>&nbsp;</span><Link className="btn btn-square btn-round btn-info" title="Edit" to={`/questionedit?id=${question.id}`}><i className="ti-pencil"></i></Link>
                        
                          <span>&nbsp;</span><Link title="Delete" onClick={() => this.setState({data: question})} className="btn btn-square btn-round btn-danger"><i className='ti-trash' data-toggle="modal" data-target="#modal-center" ></i> </Link>

                          {/* <div className="dropdown table-action">
                            <span className="dropdown-toggle no-caret hover-primary" data-toggle="dropdown" title="More"><i class="ti-more-alt rotate-90"></i></span>
                            <div className="dropdown-menu dropdown-menu-right">
                              <a className="dropdown-item" href="/"><i class="ti-menu-alt"></i> Details</a>
                              <a className="dropdown-item" href="/"><i class="ti-clip"></i> Add file</a>
                              <a className="dropdown-item" href="/"><i class="ti-bar-chart"></i> Performance</a>
                            </div>
                          </div> */}
                        </td>
                      </tr>
                      
                    })
                  }
                  </tbody>
                </table>

                <footer className="card-footer text-right">
                    <Link className="btn btn-secondary" to="/categoryindex">Back</Link>
                </footer>
            </form>
        </div>
    )
  }
}

// Functional wrapper to provide navigate
const MyComponentWithNavigate = () => {
  const navigate = useNavigate();
  return <CategoryView navigate={navigate} />;
};

export default MyComponentWithNavigate;